// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__4zf9d","icon--small":"styles_icon--small__mcUkS"};